import React, { useMemo, useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'reduxTyped'
import { l } from '@manychat/manyui'

import { useSelectedGoalData } from 'apps/aiAutomation/components/EngagementGoalEditor/hooks/useSelectedGoalData'
import {
  AiAutomationEngagementGoalActions,
  AiAutomationEngagementGoalSelectors,
} from 'apps/aiAutomation/store/engagementGoal'
import { UserField } from 'apps/aiStepStats/components/UserField/UserField'
import { getAiAgentAvailableFields } from 'common/fields/linking/accountAvailableFields'
import { GoalType } from 'shared/api/requests/aiEngagementGoal/schemas'

import { addFields, sortCollectedFields } from './lib/userFieldsUtils'

import cm from './LeadQualStats.module.css'

export const LeadQualStats = () => {
  const dispatch = useAppDispatch()

  const { selectedGoalId, selectedGoal } = useSelectedGoalData()

  const stats = useAppSelector((state) =>
    AiAutomationEngagementGoalSelectors.getStatsById(state, selectedGoalId),
  )
  const fields = useAppSelector(getAiAgentAvailableFields)

  const collectedFields = useMemo(() => {
    if (!selectedGoal || selectedGoal.type !== GoalType.LEAD_QUAL || !stats.details) {
      return []
    }

    const collected = [
      ...stats.details.sufs.map(addFields(fields)),
      ...stats.details.cufs.map(addFields(fields, 'cuf_')),
    ]

    return sortCollectedFields(collected, selectedGoal.data.fields, fields)
  }, [selectedGoal, stats.details, fields])

  useEffect(() => {
    if (selectedGoalId) {
      dispatch(AiAutomationEngagementGoalActions.getStatsFx(selectedGoalId))
    }
  }, [dispatch, selectedGoalId])

  return (
    <div className="o-auto p-x p-y-md">
      <div>
        <p className="text-subheading m-b">{l.translate('Collect information goal')}</p>

        <div className={cm.table__head}>
          <div className={cm.table__headCell}>{l.translate('Goal status')}</div>
          <div className={cm.table__headCell}>{l.translate('Contacts')}</div>
        </div>

        <div className={cm.table__body}>
          <div className={cm.table__row}>
            <div className={cm.table__cell}>{l.translate('Started')}</div>
            <div className={cm.table__cell}>{stats.started}</div>
          </div>
          <div className={cm.table__row}>
            <div className={cm.table__cell}>{l.translate('Finished')}</div>
            <div className={cm.table__cell}>{stats.achieved}</div>
          </div>
        </div>

        <div className={cm.conversion}>
          <span className="font-semibold">
            {l.percent((stats.started ? stats.achieved / stats.started : 0) * 100, 0)}
          </span>
          <span className="text-secondary">
            {l.translate(
              '<l10n context="10% of conversations completed"/>of conversations completed',
            )}
          </span>
        </div>
      </div>

      {collectedFields.length > 0 && (
        <div className="m-t-lg">
          <p className="text-subheading m-b">{l.translate('Data collected')}</p>

          <div className={cm.table__head}>
            <div className={cm.table__headCell}>{l.translate('Info collected')}</div>
            <div className={cm.table__headCell}>{l.translate('Contacts')}</div>
          </div>

          <div className={cm.table__body}>
            {collectedFields.map(({ data, field, stats }) => (
              <div key={data.id} className={cm.table__row}>
                <div className={cm.table__cell}>
                  <UserField field={field} />
                </div>
                <div className={cm.table__cell}>{stats.saved}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
